<template>
  <div style="position: relative;">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>薪资发放</el-breadcrumb-item>
      <el-breadcrumb-item>操作</el-breadcrumb-item>
      <el-breadcrumb-item>{{formData.PaPayroll.name}}</el-breadcrumb-item>
    </el-breadcrumb>

    <el-form ref="EditPayrollUserSalaryFilter" :model="EditPayrollUserSalary" :size="defaultFormItemSize"
             label-width="100px" label-position="right" @submit.native.prevent style="margin-top: 20px"
    >
      <filter-box :item-width="350">
        <el-form-item label="部门名称" prop="formFilter.deptName">
          <el-input class="filter-item" v-model="EditPayrollUserSalary.formFilter.deptName"
                    :clearable="true" placeholder="部门名称"
          />
        </el-form-item>
        <el-form-item label="员工姓名" prop="formFilter.userName">
          <el-input class="filter-item" v-model="EditPayrollUserSalary.formFilter.userName"
                    :clearable="true" placeholder="员工姓名"
          />
        </el-form-item>
        <el-form-item label="薪级名称" prop="formFilter.jobLevelName">
          <el-input class="filter-item" v-model="EditPayrollUserSalary.formFilter.jobLevelName"
                    :clearable="true" placeholder="薪级名称"
          />
        </el-form-item>
        <el-form-item label="参与绩效" prop="formFilter.paFlag">
          <el-select class="filter-item" v-model="EditPayrollUserSalary.formFilter.paFlag" :clearable="true" filterable
                     placeholder="参与绩效" :loading="EditPayrollUserSalary.paFlag.impl.loading"
                     @visible-change="EditPayrollUserSalary.paFlag.impl.onVisibleChange"
                     @change="onPaFlagValueChange">
            <el-option v-for="item in EditPayrollUserSalary.paFlag.impl.dropdownList" :key="item.id" :value="item.id" :label="item.name" />
          </el-select>
        </el-form-item>
        <el-form-item label="状态" prop="formFilter.status">
          <el-select class="filter-item" v-model="EditPayrollUserSalary.formFilter.status" :clearable="true" filterable
                     placeholder="状态" :loading="EditPayrollUserSalary.status.impl.loading"
                     @visible-change="EditPayrollUserSalary.status.impl.onVisibleChange"
                     @change="onStatusValueChange">
            <el-option v-for="item in EditPayrollUserSalary.status.impl.dropdownList" :key="item.id" :value="item.id" :label="item.name" />
          </el-select>
        </el-form-item>
        <el-button slot="operator" type="default" :plain="true" :size="defaultFormItemSize" @click="onResetEditPayrollUserSalary">重置</el-button>
        <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" @click="refreshEditPayrollUserSalary(true)">查询</el-button>
        <el-button slot="operator" type="primary" :size="defaultFormItemSize" :disabled="!checkPermCodeExist('PaPayroll:PaPayroll:export')"
                   @click="onExportClick()">
          导出
        </el-button>
        <el-button slot="operator" type="primary" :size="defaultFormItemSize" :disabled="!checkPermCodeExist('EditPayrollUserSalary:EditPayrollUserSalary:submitAssess')" v-show="formData.PaPayroll.status==='in_config'"
                   @click="onSubmitAssessClick()">
          提交评审
        </el-button>
        <el-button slot="operator" type="primary" :size="defaultFormItemSize" :disabled="!checkPermCodeExist('EditPayrollUserSalary:EditPayrollUserSalary:submitAssess')" v-show="formData.PaPayroll.status==='in_assess'"
                   @click="onSubmitBackAssessClick()">
          撤销评审提交
        </el-button>
        <el-button slot="operator" type="primary" :size="defaultFormItemSize" :disabled="!checkPermCodeExist('EditPayrollUserSalary:EditPayrollUserSalary:accountingPayroll')"
                   v-show="formData.PaPayroll.status==='in_assess' && formData.PaPayroll.scoreMethod==='1'"
                   @click="onAccountingPayrollClick()">
          核算薪资(总金额)
        </el-button>
        <el-button slot="operator" type="primary" :size="defaultFormItemSize" :disabled="!checkPermCodeExist('EditPayrollUserSalary:EditPayrollUserSalary:accountingPayroll')"
                   v-show="formData.PaPayroll.status==='in_assess' && formData.PaPayroll.scoreMethod==='2'"
                   @click="onAccountingPayrollClick()">
          核算薪资(系数)
        </el-button>
        <el-button slot="operator" type="primary" :size="defaultFormItemSize" :disabled="!checkPermCodeExist('EditPayrollUserSalary:EditPayrollUserSalary:lockedPayroll')" v-show="formData.PaPayroll.status==='in_assess'"
                   @click="onLockedPayrollClick()">
          锁定发放
        </el-button>
      </filter-box>
    </el-form>
    <el-form ref="EditPayrollUserSalary" :model="formData" class="full-width-input" style="width: 100%;"
             label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="20">
        <el-col :span="14" class="gutter-bottom">
          <el-card class="base-card" shadow="never">
            <div slot="header" class="base-card-header">
              <span>员工列表</span>
              <div class="base-card-operation" v-show="formData.PaPayroll.status==='in_config'">
                <el-button @click="onDeleteBatchUserClick()" type="primary" :size="defaultFormItemSize"
                           :disabled="!checkPermCodeExist('EditPayrollUserSalary:EditPayrollUserSalary:deleteBatchUser')">
                  删除
                </el-button>
                <el-button @click="onSelectUserClick()" type="primary" :size="defaultFormItemSize"
                           :disabled="!checkPermCodeExist('EditPayrollUserSalary:EditPayrollUserSalary:SelectUser')">
                  添加
                </el-button>
              </div>
            </div>
            <el-row class="no-scroll" :gutter="20">
              <el-col class="table-box gutter-bottom" :span="24">
                <el-table ref="paPayrollLine" :data="EditPayrollUserSalary.PaPayrollLine.impl.dataList" :size="defaultFormItemSize" @sort-change="EditPayrollUserSalary.PaPayrollLine.impl.onSortChange"
                  header-cell-class-name="table-header-gray" highlight-current-row @current-change="EditPayrollUserSalary.PaPayrollLine.impl.currentRowChange"
                  @row-click="handleRowClick" row-key="id" height="500px"
                >
                  <el-table-column type="selection" width="45px"></el-table-column>
                  <el-table-column label="序号" header-align="center" align="center" type="index" width="45px" :index="EditPayrollUserSalary.PaPayrollLine.impl.getTableIndex" />
                  <el-table-column label="工资月份" prop="salaryMonth">
                  </el-table-column>
                  <el-table-column label="部门名称" prop="deptName" width="220px">
                  </el-table-column>
                  <el-table-column label="员工姓名" prop="userName">
                  </el-table-column>
                  <el-table-column label="状态" prop="statusDictMap.name">
                  </el-table-column>
                  <el-table-column label="总金额" prop="totalAmount">
                  </el-table-column>
                  <el-table-column label="薪级名称" prop="jobLevelName" width="130px">
                  </el-table-column>
                  <el-table-column label="参与绩效" prop="paFlagDictMap.name">
                  </el-table-column>
                  <el-table-column label="目标工作量" prop="goalWorkNum" align="center" width="100px">
                  </el-table-column>
                  <el-table-column label="本次工作量" prop="thisWorkNum" align="center" width="100px">
                  </el-table-column>
                  <el-table-column label="下次工作量" prop="nextWorkNum" align="center" width="100px">
                  </el-table-column>
                  <el-table-column label="绩效截止时间" prop="paEndTime" width="120px">
                    <template slot-scope="scope">
                      <span>{{formatDateByStatsType(scope.row.paEndTime, 'day')}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="绩效分数(作品)" prop="paScore">
                  </el-table-column>
                  <el-table-column label="考评时间" prop="assessTime">
                    <template slot-scope="scope">
                      <span>{{formatDateByStatsType(scope.row.assessTime, 'day')}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="考评系数" prop="assessRatio">
                  </el-table-column>
                  <el-table-column label="激励加分" prop="goalScore">
                  </el-table-column>
                  <el-table-column label="有效分数" prop="assessScore">
                  </el-table-column>
                  <el-table-column label="基本工资" prop="baseSalary">
                  </el-table-column>
                  <el-table-column label="岗位工资" prop="jobSalary">
                  </el-table-column>
                  <el-table-column label="绩效工资" prop="paSalary">
                  </el-table-column>
                  <el-table-column label="奖金" prop="bonusAmount">
                  </el-table-column>
                  <el-table-column label="扣减金额" prop="deductAmount">
                  </el-table-column>
                  <el-table-column label="其他工资" prop="otherSalary">
                  </el-table-column>
                  <el-table-column label="创建人" prop="createUserIdDictMap.name">
                  </el-table-column>
                  <el-table-column label="创建时间" prop="createTime" width="140px">
                    <template slot-scope="scope">
                      <span>{{formatDateByStatsType(scope.row.createTime, 'datetime')}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="更新人" prop="updateUserIdDictMap.name">
                  </el-table-column>
                  <el-table-column label="更新时间" prop="updateTime" width="140px">
                    <template slot-scope="scope">
                      <span>{{formatDateByStatsType(scope.row.updateTime, 'datetime')}}</span>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </el-card>
        </el-col>
        <el-col :span="10" class="gutter-bottom">
          <el-card class="base-card" shadow="never">
            <div slot="header" class="base-card-header">
              <span>薪资项目</span>
              <div class="base-card-operation" v-show="formData.PaPayroll.status==='in_config'">
                <el-button @click="onEmptyBatchClick()" type="primary" :size="defaultFormItemSize"
                           :disabled="!checkPermCodeExist('EditPayrollUserSalary:EditPayrollUserSalary:emptyBatch')">
                  批量清空
                </el-button>
                <el-button @click="onResetBatchClick()" type="primary" :size="defaultFormItemSize"
                           :disabled="!checkPermCodeExist('EditPayrollUserSalary:EditPayrollUserSalary:resetBatch')">
                  批量重置
                </el-button>
                <el-button @click="onBatchAddPaPayrollIndexClick()" type="primary" :size="defaultFormItemSize"
                           :disabled="!checkPermCodeExist('EditPayrollUserSalary:EditPayrollUserSalary:BatchAddPaPayrollIndex')">
                  批量添加
                </el-button>
                <el-button @click="onResetClick()" type="primary" :size="defaultFormItemSize"
                           :disabled="!checkPermCodeExist('EditPayrollUserSalary:EditPayrollUserSalary:reset') || !resetEnabled">
                  重置
                </el-button>
                <el-button @click="onEditPaPayrollIndexClick()" type="primary" :size="defaultFormItemSize"
                           :disabled="!checkPermCodeExist('EditPayrollUserSalary:EditPayrollUserSalary:EditPaPayrollIndex') || !editPaPayrollIndexEnabled">
                  编辑
                </el-button>
              </div>
            </div>
            <el-row class="no-scroll" :gutter="20">
              <el-col class="table-box gutter-bottom" :span="24">
                <el-table ref="paPayrollIndex" :data="EditPayrollUserSalary.PaPayrollIndex.impl.dataList" :size="defaultFormItemSize" @sort-change="EditPayrollUserSalary.PaPayrollIndex.impl.onSortChange"
                          header-cell-class-name="table-header-gray" row-key="id" default-expand-all height="500px"
                >
                  <!--<el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="EditPayrollUserSalary.PaPayrollIndex.impl.getTableIndex" />-->
                  <el-table-column label="名称" prop="name" width="250px">
                  </el-table-column>
                  <el-table-column label="参数" prop="paramVariable" width="200px">
                    <template slot-scope="scope">
                      <span v-if="scope.row.gcode!=='pa_work'">{{scope.row.paramVariable}}</span>
                      <div v-if="scope.row.gcode==='pa_work'">
                        <el-row :gutter="20">
                          <el-col :span="12">
                            <el-tag>权重系数：{{scope.row.pa_work.indexWeightValue}}</el-tag>
                          </el-col>
                          <el-col :span="12" v-if="scope.row.code==='work_lv_a_rate'">
                            <el-tag>满分线：{{scope.row.pa_work.fullScoreLine}}%</el-tag>
                          </el-col>
                          <el-col :span="12" v-if="scope.row.code==='work_lv_a_rate'">
                            <el-tag>扣分系数：{{scope.row.pa_work.deductionFactor}}</el-tag>
                          </el-col>
                        </el-row>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="指标值" prop="indexValue">
                    <template slot-scope="scope">
                      {{scope.row.indexValue}}
                    </template>
                  </el-table-column>
                  <el-table-column label="金额" prop="indexResult">
                  </el-table-column>
                  <el-table-column label="计算公式" prop="evalFormula">
                  </el-table-column>
                  <el-table-column label="评委评分" prop="judgeScore">
                  </el-table-column>
                  <el-table-column label="评委评级" prop="judgeAssessLv">
                  </el-table-column>
                  <el-table-column label="上级评分" prop="superiorScore">
                  </el-table-column>
                  <el-table-column label="自评得分" prop="selfScore">
                  </el-table-column>
                  <el-table-column label="自评描述" prop="selfAssess">
                  </el-table-column>
                  <el-table-column label="自评时间" prop="selfAssessTime">
                    <template slot-scope="scope">
                      <span>{{formatDateByStatsType(scope.row.selfAssessTime, 'day')}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="上级" prop="superiorIdDictMap.name">
                  </el-table-column>
                  <el-table-column label="上级评分描述" prop="superiorAssess" width="100px">
                  </el-table-column>
                  <el-table-column label="上级评价时间" prop="superiorAssessTime" width="100px">
                    <template slot-scope="scope">
                      <span>{{formatDateByStatsType(scope.row.superiorAssessTime, 'day')}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="评委" prop="judgeIdDictMap.name">
                  </el-table-column>
                  <el-table-column label="评委评价内容" prop="judgeAssess" width="100px">
                  </el-table-column>
                  <el-table-column label="评委评价时间" prop="judgeAssessTime" width="100px">
                    <template slot-scope="scope">
                      <span>{{formatDateByStatsType(scope.row.judgeAssessTime, 'day')}}</span>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </el-card>
        </el-col>
      </el-row>
    </el-form>
    <label v-if="closeVisible == '1'" class="page-close-box">
      <el-button type="text" @click="onCancel(true)" icon="el-icon-close" />
    </label>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
/* eslint-disable-next-line */
import {findTreeNode, findTreeNodePath, findItemFromList, treeDataTranslate} from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { PaPayrollLineController, PaPayrollController, PaPayrollIndexController, DictionaryController } from '@/api';
import batchAddPaPayrollIndex from '@/views/PaPayroll/batchAddPaPayrollIndex.vue';
import selectUser from '@/views/UserInfo/selectUser.vue';
import editPaPayrollIndex from '@/views/PaPayroll/editPaPayrollIndex.vue';

export default {
  name: 'EditPayrollUserSalary',
  props: {
    payrollId: {
      default: undefined
    },
    name: {
      default: undefined
    },
    closeVisible: {
      type: [Number, String],
      default: 0
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin],
  data () {
    return {
      formData: {
        PaPayrollIndex: {
          id: undefined,
          payrollId: undefined,
          pid: undefined,
          payrollLineId: undefined,
          name: undefined,
          code: undefined,
          gcode: undefined,
          type: undefined,
          enableCondition: undefined,
          inputVariable: undefined,
          paramVariable: undefined,
          indexValue: undefined,
          verifyRule: undefined,
          evalFormula: undefined,
          taskCode: undefined,
          indexModelId: undefined,
          indexResult: undefined,
          sort: undefined,
          detail: undefined,
          remark: undefined,
          selfId: undefined,
          selfScore: undefined,
          selfAssess: undefined,
          selfAssessTime: undefined,
          superiorScore: undefined,
          superiorAssess: undefined,
          superiorAssessTime: undefined,
          superiorId: undefined,
          judgeAssessLv: undefined,
          judgeId: undefined,
          judgeAssess: undefined,
          judgeAssessTime: undefined,
          judgeScore: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          isDatasourceInit: false
        },
        PaPayrollLine: {
          id: undefined,
          payrollId: undefined,
          deptId: undefined,
          deptName: undefined,
          deptTid: undefined,
          userId: undefined,
          userName: undefined,
          jobLevelId: undefined,
          jobLevelName: undefined,
          status: undefined,
          paFlag: undefined,
          goalScore: undefined,
          goalWorkNum: undefined,
          thisWorkNum: undefined,
          nextWorkNum: undefined,
          paEndTime: undefined,
          paScore: undefined,
          assessTime: undefined,
          assessRatio: undefined,
          assessScore: undefined,
          baseSalary: undefined,
          jobSalary: undefined,
          paSalary: undefined,
          bonusAmount: undefined,
          deductAmount: undefined,
          otherSalary: undefined,
          totalAmount: undefined,
          contextData: undefined,
          salaryMonth: undefined,
          detail: undefined,
          name: undefined,
          remark: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          paPayrollIndex: {
          },
          isDatasourceInit: false
        },
        PaPayroll: {
          id: undefined,
          type: undefined,
          name: undefined,
          status: undefined,
          paYear: undefined,
          paMonth: undefined,
          paQuarter: undefined,
          paDay: undefined,
          paFlag: undefined,
          paTotalAmount: undefined,
          paStartTime: undefined,
          paEndTime: undefined,
          paTotalScore: undefined,
          assessStartTime: undefined,
          assessEndTime: undefined,
          assessTotalScore: undefined,
          scoreRatio: undefined,
          totalUserNum: undefined,
          totalPayrollAmount: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          scoreMethod: undefined,
          paPayrollLine: {
          },
          paPayrollIndex: {
          },
          isDatasourceInit: false
        }
      },
      EditPayrollUserSalary: {
        formFilter: {
          deptName: undefined,
          userName: undefined,
          jobLevelName: undefined,
          paFlag: undefined,
          paSalary: [],
          totalAmount: [],
          salaryMonth: [],
          status: undefined
        },
        formFilterCopy: {
          deptName: undefined,
          userName: undefined,
          jobLevelName: undefined,
          paFlag: undefined,
          paSalary: [],
          totalAmount: [],
          salaryMonth: [],
          status: undefined
        },
        PaPayrollLine: {
          impl: new TableWidget(this.loadPaPayrollLineWidgetData, this.loadPaPayrollLineVerify, false, true, 'userName', 1)
        },
        PaPayrollIndex: {
          impl: new TableWidget(this.loadPaPayrollIndexWidgetData, this.loadPaPayrollIndexVerify, false, false, 'sort', 1)
        },
        paFlag: {
          impl: new DropdownWidget(this.loadPaFlagDropdownList)
        },
        status: {
          impl: new DropdownWidget(this.loadStatusDropdownList)
        },
        PaPayrollLIneDiv: {
          isInit: false
        },
        PaPayrollIndexDiv: {
          isInit: false
        },
        isInit: false
      }
    }
  },
  methods: {
    /**
     * 导出
     */
    onExportClick () {
      let params = {
        paPayrollDtoFilter: {
          id: this.payrollId
        }
      };
      PaPayrollController.export(this, params, '工资发放.xlsx').then(res => {
        this.$message.success('导出成功');
      }).catch(e => {
        this.$message.error(e.errorMessage);
      });
    },
    handleRowClick (row, column, event) {
      // this.$refs.paPayrollLine.toggleRowSelection(row);
    },
    onCancel (isSuccess) {
      this.removeCachePage(this.$options.name);
      this.refreshParentCachedPage = isSuccess;
      this.$router.go(-1);
    },
    onResetEditPayrollUserSalary () {
      this.$refs.EditPayrollUserSalaryFilter.resetFields();
      this.refreshEditPayrollUserSalary(true);
    },
    /**
     * 工资发放行数据获取函数，返回Promise
     */
    loadPaPayrollLineWidgetData (params) {
      if (params == null) params = {};
      params = {
        ...params,
        paPayrollLineDtoFilter: {
          payrollId: this.payrollId,
          deptName: this.EditPayrollUserSalary.formFilterCopy.deptName,
          userName: this.EditPayrollUserSalary.formFilterCopy.userName,
          jobLevelName: this.EditPayrollUserSalary.formFilterCopy.jobLevelName,
          status: this.EditPayrollUserSalary.formFilterCopy.status,
          paFlag: this.EditPayrollUserSalary.formFilterCopy.paFlag
        }
      }
      return new Promise((resolve, reject) => {
        PaPayrollLineController.list(this, params).then(res => {
          resolve({
            dataList: res.data.dataList,
            totalCount: res.data.totalCount
          });
          // 恢复当前选择行
          if (this.EditPayrollUserSalary.PaPayrollLine.impl.currentRow !== null) {
            this.$nextTick(() => {
              let currentRow = findItemFromList(res.data.dataList, this.EditPayrollUserSalary.PaPayrollLine.impl.currentRow.id, 'id');
              this.$refs.paPayrollLine.setCurrentRow(currentRow);
            });
          }
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 工资发放行数据获取检测函数，返回true正常获取数据，返回false停止获取数据
     */
    loadPaPayrollLineVerify () {
      this.EditPayrollUserSalary.formFilterCopy.deptName = this.EditPayrollUserSalary.formFilter.deptName;
      this.EditPayrollUserSalary.formFilterCopy.userName = this.EditPayrollUserSalary.formFilter.userName;
      this.EditPayrollUserSalary.formFilterCopy.jobLevelName = this.EditPayrollUserSalary.formFilter.jobLevelName;
      this.EditPayrollUserSalary.formFilterCopy.status = this.EditPayrollUserSalary.formFilter.status;
      this.EditPayrollUserSalary.formFilterCopy.paFlag = this.EditPayrollUserSalary.formFilter.paFlag;
      return true;
    },
    /**
     * 工资发放指标数据获取函数，返回Promise
     */
    loadPaPayrollIndexWidgetData (params) {
      let payrollLineId = (this.EditPayrollUserSalary.PaPayrollLine.impl.currentRow || {}).id;
      if (payrollLineId === undefined || payrollLineId === 0) {
        return;
      }
      if (params == null) params = {};
      params = {
        ...params,
        paPayrollIndexDtoFilter: {
          payrollLineId: payrollLineId
        }
      }
      return new Promise((resolve, reject) => {
        PaPayrollIndexController.list(this, params).then(res => {
          let dataList = res.data.dataList;
          for (let i = 0; i < dataList.length; i++) {
            if (dataList[i].type !== 'index') {
              // dataList[i].levelCodeDictMap.name = '';
              // dataList[i].detail = '';
            }
            if (dataList[i].gcode === 'pa_work') {
              dataList[i].pa_work = JSON.parse(dataList[i].detail);
            }
          }
          resolve({
            dataList: treeDataTranslate(dataList, 'id', 'pid'),
            totalCount: res.data.totalCount
          });
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 工资发放指标数据获取检测函数，返回true正常获取数据，返回false停止获取数据
     */
    loadPaPayrollIndexVerify () {
      return true;
    },
    /**
     * 参与绩效下拉数据获取函数
     */
    loadPaFlagDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictYN(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 参与绩效选中值改变
     */
    onPaFlagValueChange (value) {
    },
    /**
     * 状态下拉数据获取函数
     */
    loadStatusDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictSysDictByParentId(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 状态选中值改变
     */
    onStatusValueChange (value) {
    },
    /**
     * 更新员工列表
     */
    refreshPaPayrollLIneDivWidget (reloadData = false) {
      // 更新容器下所有的数据组件
      if (reloadData) {
        this.EditPayrollUserSalary.PaPayrollLine.impl.refreshTable(true, 1);
      } else {
        this.EditPayrollUserSalary.PaPayrollLine.impl.refreshTable();
      }
      this.EditPayrollUserSalary.PaPayrollLIneDiv.isInit = true;
      this.refreshPaPayrollIndexDivWidget();
    },
    /**
     * 更新薪资项目
     */
    refreshPaPayrollIndexDivWidget (reloadData = false) {
      // 更新容器下所有的数据组件
      if (reloadData) {
        this.EditPayrollUserSalary.PaPayrollIndex.impl.refreshTable(true, 1);
      } else {
        this.EditPayrollUserSalary.PaPayrollIndex.impl.refreshTable();
      }
      this.EditPayrollUserSalary.PaPayrollIndexDiv.isInit = true;
    },
    /**
     * 更新人员薪资项目
     */
    refreshEditPayrollUserSalary (reloadData = false) {
      this.loadPaPayrollData();
      if (reloadData) {
        this.EditPayrollUserSalary.PaPayrollLine.impl.refreshTable(true, 1);
      } else {
        this.EditPayrollUserSalary.PaPayrollLine.impl.refreshTable();
      }
      if (reloadData) {
        this.EditPayrollUserSalary.PaPayrollIndex.impl.refreshTable(true, 1);
      } else {
        this.EditPayrollUserSalary.PaPayrollIndex.impl.refreshTable();
      }
      if (!this.EditPayrollUserSalary.isInit) {
        // 初始化下拉数据
      }
      this.EditPayrollUserSalary.isInit = true;
    },
    /**
     * 删除
     */
    onDeleteClick (row) {
      let params = {
        id: row.id
      };

      this.$confirm('是否删除').then(res => {
        PaPayrollLineController.delete(this, params).then(res => {
          this.$message.success('删除成功');
          this.refreshPaPayrollLIneDivWidget();
        }).catch(e => {});
      }).catch(e => {});
    },
    /**
     * 批量清空
     */
    onEmptyBatchClick () {
      let lines = this.$refs.paPayrollLine.selection;
      if (lines.length === 0) {
        this.$message.error('请勾选要[清空薪资项目]的员工!');
        return;
      }

      let payrollLineIds = [];
      for (let i = 0; i < lines.length; i++) {
        payrollLineIds.push(lines[i].id);
      }
      this.$confirm('是否[批量清空]所选员工的薪资项目?').then(res => {
        let params = {
          payrollLineIds: payrollLineIds
        };
        PaPayrollIndexController.emptyBatch(this, params).then(res => {
          this.$message.success('批量清空成功');
          this.refreshPaPayrollIndexDivWidget();
        }).catch(e => {});
      }).catch(e => {});
    },
    /**
     * 批量重置
     */
    onResetBatchClick () {
      let lines = this.$refs.paPayrollLine.selection;
      if (lines.length === 0) {
        this.$message.error('请勾选要[重置薪资项目]的员工!');
        return;
      }

      let payrollLineIds = [];
      for (let i = 0; i < lines.length; i++) {
        payrollLineIds.push(lines[i].id);
      }
      this.$confirm('是否[重置]所选员工的薪资项目?').then(res => {
        let params = {
          payrollLineIds: payrollLineIds
        };
        PaPayrollIndexController.resetBatch(this, params).then(res => {
          this.$message.success('批量重置成功');
          this.refreshPaPayrollIndexDivWidget();
        }).catch(e => {});
      }).catch(e => {});
    },
    /**
     * 批量添加
     */
    onBatchAddPaPayrollIndexClick () {
      let lines = this.$refs.paPayrollLine.selection;
      if (lines.length === 0) {
        this.$message.error('请勾选要[重置薪资项目]的员工!');
        return;
      }

      let payrollLineIds = [];
      for (let i = 0; i < lines.length; i++) {
        payrollLineIds.push(lines[i].id);
      }

      let params = {
        payrollId: this.formData.PaPayroll.id,
        payrollLineIds: payrollLineIds
      };

      this.$dialog.show('批量添加', batchAddPaPayrollIndex, {
        area: '1100px', offset: '10px'
      }, params).then(res => {
        this.refreshPaPayrollIndexDivWidget();
      }).catch(e => {});
    },
    /**
     * 重置
     */
    onResetClick () {
      this.$refs.EditPayrollUserSalary.validate((valid) => {
        if (!valid) return;
        let params = {
          payrollLineId: (this.EditPayrollUserSalary.PaPayrollLine.impl.currentRow || {}).id
        };

        this.$confirm('是否重置当前员工薪资项目?').then(res => {
          PaPayrollIndexController.reset(this, params).then(res => {
            this.$message.success('重置成功');
            this.refreshPaPayrollIndexDivWidget();
          }).catch(e => {});
        }).catch(e => {});
      });
    },
    /**
     * 编辑
     */
    onEditPaPayrollIndexClick () {
      let params = {
        payrollLineId: (this.EditPayrollUserSalary.PaPayrollLine.impl.currentRow || {}).id
      };

      this.$dialog.show('编辑', editPaPayrollIndex, {
        area: '1100px', offset: '10px'
      }, params).then(res => {
        this.refreshPaPayrollIndexDivWidget();
      }).catch(e => {});
    },
    /**
     * 提交评审
     */
    onSubmitAssessClick () {
      let that = this;
      this.$refs.EditPayrollUserSalary.validate((valid) => {
        if (!valid) return;
        let params = {
          id: this.payrollId
        };

        this.$confirm('是否提交评审?').then(res => {
          PaPayrollController.submitAssess(this, params).then(res => {
            that.formData.PaPayroll = res.data;
            this.$message.success('提交评审成功');
            this.refreshEditPayrollUserSalary();
          }).catch(e => {});
        }).catch(e => {});
      });
    },
    /**
     * 撤销评审提交
     */
    onSubmitBackAssessClick () {
      let that = this;
      this.$refs.EditPayrollUserSalary.validate((valid) => {
        if (!valid) return;
        let params = {
          id: this.payrollId
        };

        this.$confirm('是否撤销评审提交?').then(res => {
          PaPayrollController.submitBackAssess(this, params).then(res => {
            that.formData.PaPayroll = res.data;
            this.$message.success('撤销成功');
            this.refreshEditPayrollUserSalary();
          }).catch(e => {});
        }).catch(e => {});
      });
    },
    /**
     * 核算薪资
     */
    onAccountingPayrollClick () {
      this.$refs.EditPayrollUserSalary.validate((valid) => {
        if (!valid) return;
        let params = {
          id: this.payrollId
        };

        this.$confirm('是否重新核算薪资?').then(res => {
          PaPayrollController.accountingPayroll(this, params).then(res => {
            this.$message.success('核算薪资成功');
            this.refreshEditPayrollUserSalary();
          }).catch(e => {});
        }).catch(e => {});
      });
    },
    /**
     * 锁定发放
     */
    onLockedPayrollClick () {
      this.$refs.EditPayrollUserSalary.validate((valid) => {
        if (!valid) return;
        let params = {
          id: this.payrollId
        };

        this.$confirm('是否锁定发放薪资?锁定后不可修改!').then(res => {
          PaPayrollController.lockedPayroll(this, params).then(res => {
            this.$message.success('锁定发放成功');
            this.refreshEditPayrollUserSalary();
          }).catch(e => {
            this.$alert(e.errorMessage, '操作失败!');
          });
        })
      });
    },
    /**
     * 选择员工
     */
    onSelectUserClick () {
      let params = {};
      this.$dialog.show('选择员工', selectUser, {
        area: '1100px', offset: '10px'
      }, params).then(res => {
        if (res.length === 0) {
          return;
        }
        PaPayrollLineController.addList(this, {paPayrollDto: this.formData.PaPayroll, sysUserDtoList: res}).then(res => {
          this.refreshPaPayrollLIneDivWidget();
        }).catch(e => {});
      }).catch(e => {});
    },
    /**
     * 批量删除
     */
    onDeleteBatchUserClick () {
      let params = {idList: []};
      let selection = this.$refs.paPayrollLine.selection;
      if (selection.length === 0) {
        this.$message.error('操作失败,请先选中要删除的行!')
        return;
      }
      for (let i = 0; i < selection.length; i++) {
        params.idList.push(selection[i].id);
      }
      this.$confirm('是否删除选中人员?').then(res => {
        PaPayrollLineController.deleteBatch(this, params).then(res => {
          this.$message.success('批量删除成功');
          this.refreshPaPayrollLIneDivWidget();
        }).catch(e => {});
      }).catch(e => {});
    },
    onResume () {
    },
    /**
     * 获取工资发放详细信息
     */
    loadPaPayrollData () {
      return new Promise((resolve, reject) => {
        if (!this.formData.PaPayroll.isDatasourceInit) {
          if (
            this.payrollId == null
          ) {
            this.resetFormData();
            reject();
            return;
          }
          let params = {
            id: this.payrollId
          };
          PaPayrollController.view(this, params).then(res => {
            this.formData.PaPayroll = {...res.data, isDatasourceInit: true};
            resolve();
          }).catch(e => {
            reject();
          });
        } else {
          this.formData.CourseSection.isDatasourceInit = true;
          resolve();
        }
      });
    },
    /**
     * 获取工资发放行详细信息
     */
    loadPaPayrollLineData () {
      return new Promise((resolve, reject) => {
        if (!this.formData.PaPayrollLine.isDatasourceInit) {
          if (
            this.payrollId == null
          ) {
            this.resetFormData();
            reject();
            return;
          }
          let params = {
            id: this.payrollId
          };
          PaPayrollLineController.view(this, params).then(res => {
            this.formData.PaPayrollLine = {...res.data, isDatasourceInit: true};
            if (this.formData.PaPayrollLine.paFlagDictMap && this.EditPayrollUserSalary.paFlag.impl.dirty) {
              this.EditPayrollUserSalary.paFlag.impl.dropdownList = [this.formData.PaPayrollLine.paFlagDictMap];
            }
            if (this.formData.PaPayrollLine.statusDictMap && this.EditPayrollUserSalary.status.impl.dirty) {
              this.EditPayrollUserSalary.status.impl.dropdownList = [this.formData.PaPayrollLine.statusDictMap];
            }
            resolve();
          }).catch(e => {
            reject();
          });
        } else {
          this.formData.CourseSection.isDatasourceInit = true;
          resolve();
        }
      });
    },
    initFormData () {
    },
    /**
     * 重置表单数据
     */
    resetFormData () {
      this.formData = {
        PaPayrollIndex: {
          id: undefined,
          payrollId: undefined,
          pid: undefined,
          payrollLineId: undefined,
          name: undefined,
          code: undefined,
          gcode: undefined,
          type: undefined,
          enableCondition: undefined,
          inputVariable: undefined,
          paramVariable: undefined,
          indexValue: undefined,
          verifyRule: undefined,
          evalFormula: undefined,
          taskCode: undefined,
          indexModelId: undefined,
          indexResult: undefined,
          sort: undefined,
          detail: undefined,
          remark: undefined,
          selfId: undefined,
          selfScore: undefined,
          selfAssess: undefined,
          selfAssessTime: undefined,
          superiorScore: undefined,
          superiorAssess: undefined,
          superiorAssessTime: undefined,
          superiorId: undefined,
          judgeAssessLv: undefined,
          judgeId: undefined,
          judgeAssess: undefined,
          judgeAssessTime: undefined,
          judgeScore: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          isDatasourceInit: false
        },
        PaPayrollLine: {
          id: undefined,
          payrollId: undefined,
          deptId: undefined,
          deptName: undefined,
          deptTid: undefined,
          userId: undefined,
          userName: undefined,
          jobLevelId: undefined,
          jobLevelName: undefined,
          status: undefined,
          paFlag: undefined,
          goalScore: undefined,
          paEndTime: undefined,
          paScore: undefined,
          assessTime: undefined,
          assessRatio: undefined,
          assessScore: undefined,
          baseSalary: undefined,
          jobSalary: undefined,
          paSalary: undefined,
          bonusAmount: undefined,
          deductAmount: undefined,
          otherSalary: undefined,
          totalAmount: undefined,
          contextData: undefined,
          salaryMonth: undefined,
          detail: undefined,
          name: undefined,
          remark: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          paPayrollIndex: {
          },
          isDatasourceInit: false
        },
        PaPayroll: {
          id: undefined,
          type: undefined,
          name: undefined,
          status: undefined,
          paYear: undefined,
          paMonth: undefined,
          paQuarter: undefined,
          paDay: undefined,
          paFlag: undefined,
          paTotalAmount: undefined,
          paStartTime: undefined,
          paEndTime: undefined,
          paTotalScore: undefined,
          assessStartTime: undefined,
          assessEndTime: undefined,
          assessTotalScore: undefined,
          scoreRatio: undefined,
          totalUserNum: undefined,
          totalPayrollAmount: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          paPayrollLine: {
          },
          paPayrollIndex: {
          },
          isDatasourceInit: false
        }
      }
    },
    formInit () {
      this.refreshEditPayrollUserSalary();
    }
  },
  computed: {
    resetEnabled () {
      return this.EditPayrollUserSalary.PaPayrollLine.impl.currentRow != null && this.EditPayrollUserSalary.PaPayrollLine.impl.currentRow.status === 'in_config';
    },
    editPaPayrollIndexEnabled () {
      return this.EditPayrollUserSalary.PaPayrollLine.impl.currentRow != null && this.EditPayrollUserSalary.PaPayrollLine.impl.currentRow.status === 'in_config';
    },
    getTabPaneHeight () {
      return (this.getMainContextHeight - 102);
    },
    ...mapGetters(['getMainContextHeight'])
  },
  mounted () {
    this.formInit();
  },
  watch: {
    'EditPayrollUserSalary.PaPayrollLine.impl.currentRow': {
      handler (newValue) {
        this.EditPayrollUserSalary.PaPayrollIndex.impl.refreshTable(true, 1);
      },
      immediate: true
    }
  }
}
</script>
